// Quick Links Card Component
// Displays navigation links to other sections
import React, { useEffect, useRef, useState } from 'react';

export function QuickLinksCard({ onNavigateToSection }) {
  const containerRef = useRef(null);
  const [isWide, setIsWide] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node || typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setIsWide(width > height);
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const links = [
    { icon: 'fa-download', label: 'Downloads', section: 'downloads' },
    { icon: 'fa-tag', label: 'Pricing', section: 'pricing' },
    { icon: 'fa-users', label: 'Community', section: 'community' },
    { icon: 'fa-graduation-cap', label: 'Learn', section: 'learn' }
  ];

  return (
    <div className="account-card">
      <div className="card-header">
        <h2 className="card-title">
          <i className="fa-solid fa-link"></i> Quick Links
        </h2>
      </div>
      <div className="card-body">
        <div
          className={`quick-links ${isWide ? 'quick-links--row' : 'quick-links--column'}`}
          ref={containerRef}
        >
          {links.map(link => (
            <button
              key={link.section}
              className="quick-link"
              onClick={() => onNavigateToSection(link.section)}
            >
              <i className={`fa-solid ${link.icon}`}></i>
              <span>{link.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
